import { Field, TextField } from '@sitecore-jss/sitecore-jss-nextjs';
import Head from 'next/head';

export type SparkleMetaFields = {
  NavigationTitle?: TextField;
  JSONPayload?: TextField;
  Section?: TextField;
  ModifiedTime?: Field;
  PublishedTime?: Field;
};

export type SparkleMetaProps = {
  fields?: SparkleMetaFields;
};

export const SparkleMeta = (props?: SparkleMetaProps) => {
  const { fields } = props || {};

  const articlePublishedTime = fields?.PublishedTime?.value?.toString();
  const articleModifiedTime = fields?.ModifiedTime?.value?.toString();
  const articleSection = fields?.Section?.value?.toString();
  const breadcrumb = fields?.NavigationTitle?.value?.toString();
  const jsonPayload = fields?.JSONPayload?.value?.toString();
  return (
    <Head>
      {articlePublishedTime && (
        <meta
          property="article:published_time"
          content={articlePublishedTime}
          key="article:published_time"
        />
      )}
      {articleModifiedTime && (
        <meta
          property="article:modified_time"
          content={articleModifiedTime}
          key="article:modified_time"
        />
      )}
      {articleSection && (
        <meta property="article:section" content={articleSection} key="article:section" />
      )}
      {breadcrumb && <meta name="breadcrumb" content={breadcrumb} key="breadcrumb" />}

      {jsonPayload && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(jsonPayload),
          }}
        />
      )}
    </Head>
  );
};
